module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_vm._v("By the same author:")]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sea Eagles of Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Empire State: How the Roman Military Built an Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Septimius Severus in Scotland"), _c('a', {
    attrs: {
      "href": "#/xhtml/02_Author#rfnintauth_*",
      "id": "fnintauth_*"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Roman Legionaries")])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ragstone to Riches")])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Julius Caesar: Rome’s Greatest Warlord")])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Old Testament Warriors")])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pertinax: The Son of a Slave Who Became Roman Emperor"), _c('a', {
    attrs: {
      "href": "#/xhtml/02_Author#rfnintauth_*"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans at War")])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Roman Britain’s Missing Legion: What Really Happened to IX Hispana?"), _c('a', {
    attrs: {
      "href": "#/xhtml/02_Author#rfnintauth_*"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Roman Conquests: Britain"), _c('a', {
    attrs: {
      "href": "#/xhtml/02_Author#rfnintauth_*"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ancient Greeks at War")])]), _vm._v(" "), _c('p', {
    staticClass: "auth2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alexander the Great versus Julius Caesar"), _c('a', {
    attrs: {
      "href": "#/xhtml/02_Author#rfnintauth_*"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "auth3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/02_Author#fnintauth_*",
      "id": "rfnintauth_*"
    }
  }, [_vm._v("*")]), _vm._v(" Denotes titles in print with Pen & Sword Books/Greenhill Books")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c96a0d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Author.vue
// module id = 60
// module chunks = 0